const desktopBreakpoint = 992;
const viewportPadding = 12;

function isDesktopNavigation() {
  return window.matchMedia(`(min-width: ${desktopBreakpoint}px)`).matches;
}

function setDropdownState(dropdown, isOpen) {
  const toggle = dropdown.querySelector(":scope > .dropdown-toggle");
  const menu = dropdown.querySelector(":scope > .dropdown-menu");

  if (!toggle || !menu) {
    return;
  }

  dropdown.classList.toggle("show", isOpen);
  toggle.classList.toggle("show", isOpen);
  toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
  menu.classList.toggle("show", isOpen);

  if (isOpen) {
    keepDropdownInViewport(dropdown, menu);
  } else {
    resetDropdownPosition(dropdown, menu);
  }
}

function resetDropdownPosition(dropdown, menu) {
  dropdown.classList.remove("site-header__dropdown--open-left");
  menu.style.removeProperty("--site-header-dropdown-offset-x");
}

function keepDropdownInViewport(dropdown, menu) {
  resetDropdownPosition(dropdown, menu);

  const initialRect = menu.getBoundingClientRect();

  if (initialRect.right <= window.innerWidth - viewportPadding && initialRect.left >= viewportPadding) {
    return;
  }

  const isSubmenu = menu.classList.contains("site-header__submenu");

  if (isSubmenu && initialRect.right > window.innerWidth - viewportPadding) {
    dropdown.classList.add("site-header__dropdown--open-left");
  }

  const adjustedRect = menu.getBoundingClientRect();
  const rightOverflow = adjustedRect.right - window.innerWidth + viewportPadding;
  const leftOverflow = viewportPadding - adjustedRect.left;

  if (rightOverflow > 0) {
    menu.style.setProperty("--site-header-dropdown-offset-x", `${-rightOverflow}px`);
  } else if (leftOverflow > 0) {
    menu.style.setProperty("--site-header-dropdown-offset-x", `${leftOverflow}px`);
  }
}

function closeChildDropdowns(dropdown) {
  Array.from(dropdown.querySelectorAll(".site-header__dropdown.show")).reverse().forEach((childDropdown) => {
    setDropdownState(childDropdown, false);
  });
}

function closeDropdownTree(dropdown) {
  closeChildDropdowns(dropdown);
  setDropdownState(dropdown, false);
}

function closeAllDropdowns(nav) {
  Array.from(nav.querySelectorAll(".site-header__dropdown.show")).reverse().forEach(closeDropdownTree);
}

function isAncestorDropdown(possibleAncestor, dropdown) {
  return possibleAncestor !== dropdown && possibleAncestor.contains(dropdown);
}

function closeDropdownsOutsideBranch(nav, dropdown) {
  Array.from(nav.querySelectorAll(".site-header__dropdown.show")).reverse().forEach((openDropdown) => {
    if (!isAncestorDropdown(openDropdown, dropdown) && openDropdown !== dropdown) {
      closeDropdownTree(openDropdown);
    }
  });
}

function closeSiblingDropdowns(dropdown) {
  const parentList = dropdown.parentElement;

  if (!parentList) {
    return;
  }

  parentList.querySelectorAll(":scope > .site-header__dropdown.show").forEach((siblingDropdown) => {
    if (siblingDropdown !== dropdown) {
      setDropdownState(siblingDropdown, false);
      closeChildDropdowns(siblingDropdown);
    }
  });
}

function bindHoverDropdowns(nav) {
  nav.querySelectorAll(".site-header__dropdown").forEach((dropdown) => {
    dropdown.addEventListener("mouseenter", () => {
      if (isDesktopNavigation()) {
        closeSiblingDropdowns(dropdown);
        setDropdownState(dropdown, true);
      }
    });

    dropdown.addEventListener("mouseleave", () => {
      if (isDesktopNavigation()) {
        closeChildDropdowns(dropdown);
        setDropdownState(dropdown, false);
      }
    });
  });
}

function bindMobileDropdowns(nav) {
  nav.addEventListener("click", (event) => {
    if (isDesktopNavigation()) {
      return;
    }

    const link = event.target.closest("a");

    if (link && !link.classList.contains("dropdown-toggle")) {
      closeAllDropdowns(nav);
    }
  });

  nav.querySelectorAll(".site-header__dropdown > .dropdown-toggle").forEach((toggle) => {
    toggle.addEventListener("click", (event) => {
      if (isDesktopNavigation()) {
        return;
      }

      const dropdown = toggle.closest(".site-header__dropdown");
      const menu = dropdown?.querySelector(":scope > .dropdown-menu");

      if (!dropdown || !menu) {
        return;
      }

      event.preventDefault();

      const shouldOpen = !menu.classList.contains("show");

      if (!shouldOpen) {
        closeDropdownTree(dropdown);
        return;
      } else {
        closeDropdownsOutsideBranch(nav, dropdown);
      }

      setDropdownState(dropdown, true);
    });
  });

  document.addEventListener("click", (event) => {
    if (isDesktopNavigation()) {
      return;
    }

    const clickedDropdown = event.target.closest(".site-header__dropdown");

    if (clickedDropdown && nav.contains(clickedDropdown)) {
      return;
    }

    closeAllDropdowns(nav);
  });
}

document.querySelectorAll("[data-navigation-interaction='hover']").forEach((nav) => {
  bindHoverDropdowns(nav);
  bindMobileDropdowns(nav);
});
